import { Routes } from '@angular/router';
import { desktopOnlyGuard } from './guards/desktop-only.guard';
import { authGuard, authChildGuard, loginRedirectGuard } from './guards/auth.guard';
import { permissionGuard } from './guards/permission.guard';
import { adminIpayOnlyGuard } from './guards/admin-ipay-only.guard';
import { appNotFoundGuard, notFoundGuard } from './guards/not-found.guard';
import { unsavedChangesGuard } from './guards/unsaved-changes.guard';

const userRoutes: Routes = [
  {
    path: 'user/login',
    canActivate: [loginRedirectGuard],
    loadComponent: () => import('./auth/user/login/login.component').then((m) => m.LoginComponent)
  },
  {
    path: 'user/password',
    canActivate: [loginRedirectGuard],
    loadComponent: () => import('./auth/user/password/password.component').then((m) => m.PasswordComponent)
  },
  {
    path: 'user/confirm',
    loadComponent: () => import('./auth/user/confirm/confirm.component').then((m) => m.ConfirmComponent)
  },
  {
    path: 'user/forgot-password',
    loadComponent: () => import('./auth/user/forgot-password/forgot-password.component').then((m) => m.ForgotPasswordComponent)
  },
  {
    path: 'user/code-sent',
    loadComponent: () => import('./auth/user/code-sent/code-sent.component').then((m) => m.CodeSentComponent)
  },
  {
    path: 'user/verify-code',
    loadComponent: () => import('./auth/user/verify-code/verify-code.component').then((m) => m.VerifyCodeComponent)
  },
  {
    path: 'user/reset-password',
    loadComponent: () => import('./auth/user/reset-password/reset-password.component').then((m) => m.ResetPasswordComponent)
  },
  {
    path: 'user/password-success',
    loadComponent: () => import('./auth/user/password-success/password-success.component').then((m) => m.PasswordSuccessComponent)
  }
];

const companyRoutes: Routes = [
  {
    path: 'company/login',
    canActivate: [loginRedirectGuard],
    loadComponent: () => import('./auth/company/login/login.component').then((m) => m.LoginComponent)
  },
  {
    path: 'company/password',
    canActivate: [loginRedirectGuard],
    loadComponent: () => import('./auth/company/password/password.component').then((m) => m.PasswordComponent)
  },
  {
    path: 'company/confirm-email',
    loadComponent: () => import('./auth/company/confirm-email/confirm-email.component').then((m) => m.ConfirmEmailComponent)
  },
  {
    path: 'company/confirm',
    loadComponent: () => import('./auth/company/confirm/confirm.component').then((m) => m.ConfirmComponent)
  },
  {
    path: 'company/forgot-password',
    loadComponent: () => import('./auth/company/forgot-password/forgot-password.component').then((m) => m.ForgotPasswordComponent)
  },
  {
    path: 'company/code-sent',
    loadComponent: () => import('./auth/company/code-sent/code-sent.component').then((m) => m.CodeSentComponent)
  },
  {
    path: 'company/verify-code',
    loadComponent: () => import('./auth/company/verify-code/verify-code.component').then((m) => m.VerifyCodeComponent)
  },
  {
    path: 'company/reset-password',
    loadComponent: () => import('./auth/company/reset-password/reset-password.component').then((m) => m.ResetPasswordComponent)
  },
  {
    path: 'company/password-success',
    loadComponent: () => import('./auth/company/password-success/password-success.component').then((m) => m.PasswordSuccessComponent)
  }
];

const dashboardRoutes: Routes = [
  {
    path: 'user',
    loadComponent: () => import('./dashboard/user/user-dashboard.component').then((m) => m.UserDashboardComponent),
    canActivate: [authGuard]
  },
  {
    path: 'company',
    loadComponent: () => import('./dashboard/company/company-dashboard.component').then((m) => m.CompanyDashboardComponent),
    canActivate: [authGuard],
    canActivateChild: [permissionGuard],
    children: [


      {
        path: 'usuarios/colaboradores/crear/:id',
        loadComponent: () => import('./dashboard/company/collaborators/create-collaborator/create-collaborator.component').then((m) => m.CreateCollaboratorComponent)
      },
      {
        path: 'usuarios/colaboradores/crear',
        loadComponent: () => import('./dashboard/company/collaborators/create-collaborator/create-collaborator.component').then((m) => m.CreateCollaboratorComponent)
      },
      {
        path: 'usuarios/colaboradores/añadir-grupo',
        loadComponent: () => import('./dashboard/company/collaborators/add-group/add-group.component').then((m) => m.AddGroupComponent)
      },
      {
        path: 'usuarios/colaboradores/inactivar-grupo',
        loadComponent: () => import('./dashboard/company/collaborators/inactivate-group/inactivate-group.component').then((m) => m.InactivateGroupComponent)
      },
      {
        path: 'usuarios/colaboradores/inactivar-colaboradores',
        loadComponent: () => import('./dashboard/company/collaborators/inactivate-colaborators-excel/inactivate-colaborators-excel.component').then((m) => m.InactivateColaboratorsExcelComponent)
      },
      {
        path: 'usuarios/colaboradores/suspender-grupo',
        loadComponent: () => import('./dashboard/company/collaborators/suspend-colaborators-excel/suspend-colaborators-excel.component').then((m) => m.SuspendColaboratorsExcelComponent)
      },
      // {
      //   path: 'usuarios/colaboradores',
      //   loadComponent: () => import('./dashboard/company/collaborators/colaboradores.component').then((m) => m.ColaboradoresComponent)
      // },

      //Despues del merge Unificar en una sola url, ya lo permite el componente
      {
        path: 'usuarios/colaboradores',
        loadComponent: () => import('./dashboard/company/users/collaborators/bandeja-collaborators/bandeja-collaborators.component').then((m) => m.BandejaCollaboratorsComponent)
      },
      {
        path: 'colaboradores/editar',
        loadComponent: () => import('./dashboard/company/users/collaborators/bandeja-collaborators/bandeja-collaborators.component').then((m) => m.BandejaCollaboratorsComponent)
        // loadComponent: () => import('./dashboard/company/dashboard/dashboard.component').then((m) => m.DashboardComponent)
        // loadComponent: () => import('./dashboard/company/collaborators/edit-collaborator/edit-collaborator.component').then((m) => m.EditCollaboratorComponent)
      },

      {
        path: 'graficas-business',
        loadComponent: () => import('./dashboard/company/dashboard/dashboard.component').then((m) => m.DashboardComponent)
      },

      // {
      //   path: 'usuarios/admin-ipay',
      //   loadComponent: () => import('./dashboard/company/collaborators/admin-ipay/admin-ipay.component').then((m) => m.AdminIpayComponent)
      // },
      {
        path: 'usuarios/admin-ipay',
        loadComponent: () => import('./dashboard/company/users/ipay-administrators/bandeja-ipay-administrators/bandeja-ipay-administrators.component').then((m) => m.BandejaIpayAdministratorsComponent)
      },
      {
        path: 'usuarios/admin-ipay/crear',
        loadComponent: () => import('./dashboard/company/collaborators/create-admin-ipay/create-admin-ipay.component').then((m) => m.CreateAdminIpayComponent)
      },
      {
        path: 'usuarios/admin-ipay/editar/:id',
        loadComponent: () => import('./dashboard/company/collaborators/create-admin-ipay/create-admin-ipay.component').then((m) => m.CreateAdminIpayComponent)
      },


      // {
      //   path: 'usuarios/administradores',
      //   loadComponent: () => import('./dashboard/company/collaborators/admin-business/admin-business.component').then((m) => m.AdminBusinessComponent)
      // },
      {
        path: 'usuarios/administradores',
        loadComponent: () => import('./dashboard/company/users/administrators/bandeja-administrators/bandeja-administrators.component').then((m) => m.BandejaAdministratorsComponent)
      },

      {
        path: 'usuarios/administradores/crear',
        loadComponent: () => import('./dashboard/company/collaborators/create-admin-business/create-admin-business.component').then((m) => m.CreateAdminBusinessComponent)
      },
      {
        path: 'usuarios/administradores/editar/:id',
        loadComponent: () => import('./dashboard/company/collaborators/create-admin-business/create-admin-business.component').then((m) => m.CreateAdminBusinessComponent)
      },


      // BUSINESS
      {
        path: 'empresas',
        loadComponent: () => import('./dashboard/company/business/bandeja-business/bandeja-business.component').then((m) => m.BandejaBusinessComponent)
      },
      {
        path: 'empresas/crear',
        loadComponent: () => import('./dashboard/company/business/save-business/save-business.component').then((m) => m.SaveBusinessComponent)
      },
      {
        path: 'empresas/actualizar',
        loadComponent: () => import('./dashboard/company/business/save-business/save-business.component').then((m) => m.SaveBusinessComponent)
      },
      {
        path: 'empresas/configuracion',
        loadComponent: () => import('./dashboard/company/business/business-config/business-config.component').then((m) => m.BusinessConfigComponent),
        canDeactivate: [unsavedChangesGuard]
      },


      // GRUPO BUSINESS
      {
        path: 'grupo-empresas',
        loadComponent: () => import('./dashboard/company/group-business/bandeja-group-business/bandeja-group-business.component').then((m) => m.BandejaGroupBusinessComponent)
      },
      {
        path: 'grupo-empresas/crear',
        loadComponent: () => import('./dashboard/company/group-business/save-group-business/save-group-business.component').then((m) => m.SaveGroupBusinessComponent)
      },
      {
        path: 'grupo-empresas/actualizar',
        loadComponent: () => import('./dashboard/company/group-business/save-group-business/save-group-business.component').then((m) => m.SaveGroupBusinessComponent)
      },


      //PRECIO SUSCRIPCION EMPRESAS
      {
        path: 'precio-suscripcion',
        loadComponent: () => import('./dashboard/company/subscription_pricing/bandeja_subscription_pricing/bandeja_subscription_pricing.component').then((m) => m.BandejaSubscriptionPricingComponent)
      },
      {
        path: 'precio-suscripcion/crear',
        loadComponent: () => import('./dashboard/company/subscription_pricing/save_subscription_pricing/save_subscription_pricing.component').then((m) => m.SaveSubscriptionPricingComponent)
      },
      {
        path: 'precio-suscripcion/actualizar',
        loadComponent: () => import('./dashboard/company/subscription_pricing/save_subscription_pricing/save_subscription_pricing.component').then((m) => m.SaveSubscriptionPricingComponent)
      },


      //SOLICITUDES EMPRESA
      {
        path: 'solicitudes/productos',
        loadComponent: () => import('./dashboard/company/solicitudes/products/bandeja-products/bandeja-products.component').then((c) => c.BandejaProductsComponent)
      },
      {
        path: 'solicitudes/productos/detalle',
        loadComponent: () => import('./dashboard/company/solicitudes/products/detalle-products/detalle-products.component').then((c) => c.DetalleProductsComponent)
      },

      {
        path: 'solicitudes/baja_colaborador',
        loadComponent: () => import('./dashboard/company/solicitudes/baja-colaborador/bandeja-baja-colaborator/bandeja-baja-colaborator.component').then((c) => c.BandejaBajaColaboratorComponent)
      },
      {
        path: 'solicitudes/baja_colaborador/detalle',
        loadComponent: () => import('./dashboard/company/solicitudes/baja-colaborador/detail-baja-colaborator/detail-baja-colaborator.component').then((c) => c.DetailBajaColaboratorComponent)
      },

      // AMORTIZACION
      {
        path: 'solicitudes/amortizacion',
        loadComponent: () => import('./dashboard/company/solicitudes/amortization/bandeja-amortization/bandeja-amortization.component').then((c) => c.BandejaAmortizationComponent)
      },
      {
        path: 'solicitudes/amortizacion/detalle',
        loadComponent: () => import('./dashboard/company/solicitudes/amortization/detail-amortization/detail-amortization.component').then((c) => c.DetailAmortizationComponent)
      },


      // PROMOCIONES
      {
        path: 'promociones',
        loadComponent: () => import('./dashboard/company/promotions/bandeja-promociones/bandeja-promociones.component').then((m) => m.BandejaPromocionesComponent)
      },

      {
        path: 'promociones/crear',
        loadComponent: () => import('./dashboard/company/promotions/save-promociones/save-promociones.component').then((m) => m.SavePromocionesComponent)
      },
      {
        path: 'promociones/actualizar',
        loadComponent: () => import('./dashboard/company/promotions/save-promociones/save-promociones.component').then((m) => m.SavePromocionesComponent)
      },
      {
        path: 'comercios',
        loadComponent: () => import('./dashboard/company/promotions/bandeja-comercios/bandeja-comercios.component').then((m) => m.BandejaComerciosComponent)
      },
      // Ruta anterior de comercios (antes era un botón dentro de Convenios).
      {
        path: 'promociones/gestionar-comercios',
        redirectTo: 'comercios'
      },

      // PRODUCTOS
      {
        path: 'productos',
        loadComponent: () => import('./dashboard/company/products/bandeja-products/bandeja-products.component').then((c) => c.BandejaProductsComponent)
      },
      {
        path: 'productos/detalle',
        loadComponent: () => import('./dashboard/company/products/detail-products/detail-products.component').then((c) => c.DetailProductsComponent)
      },
      // DESEMBOLSOS
      {
        path: 'desembolsos',
        canActivate: [adminIpayOnlyGuard],
        loadComponent: () => import('./dashboard/company/disbursements/bandeja-disbursements/bandeja-disbursements.component').then((c) => c.BandejaDisbursementsComponent)
      },
      {
        path: 'transacciones',
        loadComponent: () => import('./dashboard/company/transactions/lista-transacciones-bussiness/lista-transacciones-bussiness.component').then((m) => m.ListaTransaccionesBussinessComponent)
      },
      // {
      //   path: 'transacciones-old',
      //   loadComponent: () => import('./dashboard/company/transactions/lista-transacciones/lista-transacciones.component').then((m) => m.ListaTransaccionesComponent)
      // },

      // CURSOS
      {
        path: 'cursos',
        loadComponent: () => import('./dashboard/company/course/bandeja-course/bandeja-course.component').then((c) => c.BandejaCourseComponent)
      },
      {
        path: 'cursos/crear',
        loadComponent: () => import('./dashboard/company/course/save-course/save-course.component').then((c) => c.SaveCourseComponent)
      },
      {
        path: 'cursos/actualizar',
        loadComponent: () => import('./dashboard/company/course/save-course/save-course.component').then((c) => c.SaveCourseComponent)
      },
      {
        path: 'cursos/leccion/crear',
        loadComponent: () => import('./dashboard/company/course/save-lesson/save-lesson.component').then((c) => c.SaveLessonComponent)
      },
      {
        path: 'cursos/leccion/actualizar',
        loadComponent: () => import('./dashboard/company/course/save-lesson/save-lesson.component').then((c) => c.SaveLessonComponent)
      },


      // LIQUIDACIONES
      {
        path: 'liquidaciones',
        loadComponent: () => import('./dashboard/company/liquidaciones/liquidaciones-wrapper.component').then((c) => c.LiquidacionesWrapperComponent)
      },


      // GESTION DE PAGOS
      {
        path: 'gestion-pagos',
        loadComponent: () => import('./dashboard/company/payment-management/bandeja-payment-management/bandeja-payment-management.component').then((c) => c.BandejaPaymentManagementComponent)
      },
      {
        path: 'gestion-pagos/pago-masivo',
        canActivate: [adminIpayOnlyGuard],
        loadComponent: () => import('./dashboard/company/payment-management/bulk-payment/bulk-payment.component').then((c) => c.BulkPaymentComponent)
      },
      {
        path: 'gestion-pagos-empresa-periodo',
        loadComponent: () => import('./dashboard/company/payment-management/bandeja-payment-management/views/view-business-period/view-business-period.component').then((c) => c.ViewBusinessPeriodComponent)
      },


      // FACTURACION
      {
        path: 'facturacion',
        loadComponent: () => import('./dashboard/company/facturation/bandeja-facturation/bandeja-facturation.component').then((c) => c.BandejaFacturationComponent)
      },
      {
        path: 'detalle-facturacion',
        loadComponent: () => import('./dashboard/company/facturation/detail-facturation/facturation-detail-layout/facturation-detail-layout.component').then((c) => c.FacturationDetailLayoutComponent)
      },


      //TOKENIZACION
      {
        path: 'tokenizacion/fondo-ipay',
        loadComponent: () => import('./dashboard/company/tokenization/ipay-fund/bandeja-ipay-fund/bandeja-ipay-fund.component').then((c) => c.BandejaIpayFundComponent)
      },
      {
        path: 'tokenizacion/sorteos',
        loadComponent: () => import('./dashboard/company/tokenization/raffles/bandeja-raffles/bandeja-raffles.component').then((c) => c.BandejaRafflesComponent)
      },
      {
        path: 'tokenizacion/registrar-sorteo',
        loadComponent: () => import('./dashboard/company/tokenization/raffles/save-raffle/save-raffle.component').then((c) => c.SaveRaffleComponent)
      },
      {
        path: 'tokenizacion/actualizar-sorteo',
        loadComponent: () => import('./dashboard/company/tokenization/raffles/save-raffle/save-raffle.component').then((c) => c.SaveRaffleComponent)
      },
      {
        path: 'tokenizacion/transacciones',
        loadComponent: () => import('./dashboard/company/tokenization/transactions/bandeja-transactions/bandeja-transactions.component').then((c) => c.BandejaTransactionsComponent)
      },
      {
        path: 'tokenizacion/configuracion',
        loadComponent: () => import('./dashboard/company/tokenization/configuration/settings/settings.component').then((c) => c.SettingsComponent)
      },
      {
        path: 'tokenizacion/ganadores',
        loadComponent: () => import('./dashboard/company/tokenization/winners/winners/winners.component').then((c) => c.WinnersComponent)
      },
      {
        path: 'configuracion-general',
        canActivate: [adminIpayOnlyGuard],
        loadComponent: () => import('./dashboard/company/general-configuration/general-settings.component').then((c) => c.GeneralSettingsComponent)
      },


      //NOTIFICACIONES TEMPLATES
      {
        path: 'notificaciones/templates',
        loadComponent: () => import('./dashboard/company/notifications-templates/bandeja-notifications-template/bandeja-notifications-template.component').then((c) => c.BandejaNotificationsTemplateComponent)
      },
      {
        path: 'notificaciones/registrar-template',
        loadComponent: () => import('./dashboard/company/notifications-templates/save-notification-template/save-notification-template.component').then((c) => c.SaveNotificationTemplateComponent)
      },
      {
        path: 'notificaciones/actualizar-template',
        loadComponent: () => import('./dashboard/company/notifications-templates/save-notification-template/save-notification-template.component').then((c) => c.SaveNotificationTemplateComponent)
      },

      // MI PERFIL (página estática: no sale de system_option, ver constants/static-pages.ts)
      {
        path: 'mi-perfil',
        loadComponent: () => import('./dashboard/company/profile/my-profile.component').then((c) => c.MyProfileComponent)
      },

      // SEGURIDAD
      {
        path: 'seguridad/opciones-sistema',
        canActivate: [adminIpayOnlyGuard],
        loadComponent: () => import('./dashboard/company/security/system-options/bandeja-system-options/bandeja-system-options.component').then((c) => c.BandejaSystemOptionsComponent)
      },
      {
        path: 'seguridad/roles',
        canActivate: [adminIpayOnlyGuard],
        loadComponent: () => import('./dashboard/company/security/roles/bandeja-roles/bandeja-roles.component').then((c) => c.BandejaRolesComponent)
      },
      {
        path: 'seguridad/roles/crear',
        canActivate: [adminIpayOnlyGuard],
        loadComponent: () => import('./dashboard/company/security/roles/save-role/save-role.component').then((c) => c.SaveRoleComponent)
      },
      {
        path: 'seguridad/roles/editar/:id',
        canActivate: [adminIpayOnlyGuard],
        loadComponent: () => import('./dashboard/company/security/roles/save-role/save-role.component').then((c) => c.SaveRoleComponent)
      },

      {
        path: 'recaudacion/business',
        loadComponent: () => import('./dashboard/company/recaudation/recaudation-business/recaudation-business.component').then((c) => c.RecaudationBusinessComponent)
      },


      // MANTENIMIENTOS
      {
        path: 'mantenimiento/bancos',
        canActivate: [adminIpayOnlyGuard],
        loadComponent: () => import('./dashboard/company/maintenance/banks/bank-management/bank-management.component').then((c) => c.BankManagementComponent)
      },
      {
        path: 'mantenimiento/cuentas-bancarias',
        canActivate: [adminIpayOnlyGuard],
        loadComponent: () => import('./dashboard/company/maintenance/bank-account/bank-account-management/bank-account-management.component').then((c) => c.BankAccountManagementComponent)
      },
      {
        path: 'mantenimiento/catalogos',
        canActivate: [adminIpayOnlyGuard],
        loadComponent: () => import('./dashboard/company/maintenance/catalogs/bandeja-catalogs/bandeja-catalogs.component').then((c) => c.BandejaCatalogsComponent)
      },
      {
        path: 'mantenimiento/monedas',
        canActivate: [adminIpayOnlyGuard],
        loadComponent: () => import('./dashboard/company/maintenance/currency/currency-management/currency-management.component').then((c) => c.CurrencyManagementComponent)
      },
      {
        path: 'mantenimiento/paises',
        canActivate: [adminIpayOnlyGuard],
        loadComponent: () => import('./dashboard/company/maintenance/country/country-management/country-management.component').then((c) => c.CountryManagementComponent)
      },
      {
        path: 'mantenimiento/tipos-documentos',
        canActivate: [adminIpayOnlyGuard],
        loadComponent: () => import('./dashboard/company/maintenance/cards-type/card-type-management/card-type-management.component').then((c) => c.CardTypeManagementComponent)
      },
      {
        path: 'mantenimiento/categorias-empresas',
        canActivate: [adminIpayOnlyGuard],
        loadComponent: () => import('./dashboard/company/maintenance/business-category/business-category-management/business-category-management.component').then((c) => c.BusinessCategoryManagementComponent)
      },
      {
        path: 'mantenimiento/software-planilla',
        canActivate: [adminIpayOnlyGuard],
        loadComponent: () => import('./dashboard/company/maintenance/payroll-software/payroll-software-management/payroll-software-management.component').then((c) => c.PayrollSoftwareManagementComponent)
      },
      {
        path: 'mantenimiento/integracion-planilla',
        canActivate: [adminIpayOnlyGuard],
        loadComponent: () => import('./dashboard/company/maintenance/payroll-integration/payroll-integration-management/payroll-integration-management.component').then((c) => c.PayrollIntegrationManagementComponent)
      },
      {
        path: 'mantenimiento/estado-colaborador',
        canActivate: [adminIpayOnlyGuard],
        loadComponent: () => import('./dashboard/company/maintenance/employee-reason/employee-reason-management/employee-reason-management.component').then((c) => c.EmployeeReasonManagementComponent)
      },
      {
        path: 'mantenimiento/ubigeo',
        canActivate: [adminIpayOnlyGuard],
        loadComponent: () => import('./dashboard/company/maintenance/ubigeo/ubigeo-management/ubigeo-management.component').then((c) => c.UbigeoManagementComponent)
      },
      {
        path: 'mantenimiento/categoria-comercio',
        canActivate: [adminIpayOnlyGuard],
        loadComponent: () => import('./dashboard/company/maintenance/commerce-category/commerce-category-management/commerce-category-management.component').then((c) => c.CommerceCategoryManagementComponent)
      },
      {
        path: 'mantenimiento/categoria-curso',
        canActivate: [adminIpayOnlyGuard],
        loadComponent: () => import('./dashboard/company/maintenance/course-category/course-category-management/course-category-management.component').then((c) => c.CourseCategoryManagementComponent)
      },

      // Debe ir al final: cualquier ruta sin página implementada (p.ej. opción de
      // menú cuya pantalla aún no existe) muestra un toast y vuelve al home.
      // La ruta vacía explícita es necesaria porque '**' también matchea
      // /dashboard/company sin hijo (home de Admin iPay) y causaría un loop.
      {
        path: '',
        pathMatch: 'full',
        children: []
      },
      {
        path: '**',
        canActivate: [notFoundGuard],
        children: []
      },
    ]
  }
];

export const routes: Routes = [
  {
    path: '',
    redirectTo: '/auth/company/login',
    pathMatch: 'full'
  },
  {
    path: 'auth/user/login',
    redirectTo: '/auth/company/login',
    pathMatch: 'full'
  },
  {
    path: 'desktop-only',
    loadComponent: () => import('./shared/desktop-only.component').then((m) => m.DesktopOnlyComponent)
  },
  {
    path: 'auth',
    canActivateChild: [desktopOnlyGuard],
    children: [
      ...userRoutes,
      ...companyRoutes
    ]
  },
  {
    path: 'dashboard',
    canActivateChild: [desktopOnlyGuard, authChildGuard],
    children: dashboardRoutes
  },
  {
    path: '**',
    canActivate: [appNotFoundGuard],
    children: []
  }
];
